import React, { useState, useEffect } from 'react';

export const PrayerList = ({ list }) => {
  const setCatDefaults = () => {
    const catArray = [];
    list.categories.forEach(() => catArray.push(false));
    return catArray;
  };

  const catFilter = ({ categories }) => {
    if (!isCatSelected.some((val) => val)) {
      return true;
    }
    const activeFilters = [];
    list.categories.reduce((activeFilters, cat, index) => {
      if (isCatSelected[index]) activeFilters.push(cat.slug);
      return activeFilters;
    }, activeFilters);
    return categories.some(({ slug }) => {
      return activeFilters.indexOf(slug) >= 0;
    });
  };

  const COUNT_INCREMENT = 20;
  const [isCatSelected, setIsCatSelected] = useState(setCatDefaults());
  const [viewCount, setViewCount] = useState(COUNT_INCREMENT);
  const [canShowMore, setCanShowMore] = useState(
    list.prayers.length > COUNT_INCREMENT
  );

  useEffect(() => {
    if (list.prayers.length > viewCount) {
      setCanShowMore(true);
    }
  }, [list.prayers, viewCount]);

  const toggleCat = (index) => {
    const newArray = isCatSelected.concat();
    newArray[index] = !isCatSelected[index];
    setIsCatSelected(newArray);
  };

  const showMore = () => {
    const newViewCount = viewCount + COUNT_INCREMENT;
    setViewCount(newViewCount);
  };

  return (
    <div>
      <ul className='asc-prayer-cat-list'>
        {list.categories
          .filter((cat, index, self) => {
            return index === self.findIndex((obj) => obj.slug === cat.slug);
          })
          .map(({ name, slug }, index) => (
            <li
              key={slug}
              onClick={(e) => {
                e.preventDefault();
                toggleCat(index);
              }}
              className={`asc-prayer-cat-item ${
                isCatSelected[index] ? 'selected' : ''
              }`}
            >
              {name.replace('&amp;', '&')}
            </li>
          ))}
      </ul>
      <ul
        className={`prayer-grid prayer-list-${list.id
          .toLowerCase()
          .replace(/\s/g, '-')}`}
      >
        {list.prayers
          .filter(catFilter)
          .filter((_, index) => index < viewCount)
          .map(({ id, prayerFor, description, categories }) => (
            <div className={`prayer-block column`} key={id}>
              <p className='prayer'>{description}</p>
              {prayerFor && (
                <div className='prayer-for'>
                  <span className='prayer-for-label'>Prayer for </span>
                  <span className='prayer-for-name'>{prayerFor}</span>
                </div>
              )}
              {categories && (
                <div className='prayer-cats'>
                  {categories.map(({ name, slug }) => (
                    <span className='prayer-cat' key={slug}>
                      {name}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
      </ul>
      {canShowMore && (
        <div className='show-more-prayers' onClick={showMore}>
          Show More
        </div>
      )}
    </div>
  );
};
